import { create } from "zustand";

interface HookProps {
  open: boolean;
  employeeId: string;
  permissions: {
    [key: string]: string[];
  };
  setPermissions: (permissions: {
    "1": string[];
    "2": string[];
    "3": string[];
  }) => void;
  setEmployeeId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const usePermissionsModal = create<HookProps>()((set) => ({
  open: false,
  employeeId: "",
  permissions: {
    "1": [],
    "2": [],
    "3": [],
  },
  setPermissions: (permissions) =>
    set(() => ({
      permissions,
    })),
  setEmployeeId: (id) =>
    set(() => ({
      employeeId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
